<template>
  <div>
    <div>
      <div class="item">
        <span class="title">消耗时间</span>
        <el-date-picker
          v-model="date"
          :picker-options="expireTimeOption"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>

      <div class="item">
        <span class="title">投放组</span>
        <el-autocomplete
          v-model="parameterNames.release_group_id_name"
          :fetch-suggestions="querySearchAsync"
          :clearable="true"
          placeholder="请输入内容"
          @clear="(parameterNames.release_group_id_name = null),(parameter.release_group_id = null)"
          @focus="current = '投放组'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">投手</span>
        <el-autocomplete
          v-model="parameterNames.pitcher_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @clear="(parameterNames.pitcher_id_name = null),(parameter.pitcher_id = null)"
          @focus="current = '投手'"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="title">小程序</span>
        <el-autocomplete
          v-model="parameterNames.mini_program_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @clear="(parameterNames.mini_program_name = null),(parameter.mini_program_id = null)"
          @focus="current = '小程序'"
          @select="handleSelect"
        />
      </div>
    </div>

    <div style="text-align: end; margin-top:20px">
      <el-button
        class=""
        type="primary"
        @click="determine"
      >确定</el-button>
    </div>
  </div>
</template>

<script>
import { getReleaseGroupList, getListOfPitchersInTheLaunchGroup, getAPPList } from '@/api/TKreleaseGroup.js'
export default {
  props: {
    drawerItem: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      expireTimeOption: {
        disabledDate(date) {}
      },
      parameter: {
        release_group_id: null, // 投放组
        pitcher_id: null, // 投手,
        mini_program_id: null // 小程序列表id
      },
      parameterNames: {
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手,
        mini_program_name: null // 小程序列表
      },
      current: null,
      loading: false,
      loading1: false,
      date: []
    }
  },
  created() {
    window.aaa = this
    this.init()
  },
  mounted() {},
  methods: {
    // 选中哪一项
    handleSelect(item) {
      switch (this.current) {
        case '投放组':
          this.parameter.release_group_id = item.id
          break
        case '投手':
          this.parameter.pitcher_id = item.address
          break
        case '小程序':
          this.parameter.mini_program_id = item.id
      }
    },
    // 搜索
    async querySearchAsync(queryString, cb) {
      let currentFunc = null
      switch (this.current) {
        case '投放组':
          currentFunc = getReleaseGroupList
          break
        case '投手':
          currentFunc = getListOfPitchersInTheLaunchGroup
          break
        case '小程序':
          currentFunc = getAPPList
      }
      if (!currentFunc) {
        return
      }
      console.log('this.current:', this.current)
      if ((this.current === '投手' && !this.parameter.release_group_id)) {
        this.$message({
          message: '请先选投放组，才能选投手',
          type: 'warning'
        })
        cb()
        return
      }
      const data = await currentFunc({
        name: queryString || null,
        group_id: this.current === '投手' ? this.parameter.release_group_id : null
      })
      if (this.current === '投手') {
        cb(
          data.data.group_user.map(item => {
            return {
              value: item.nickname,
              address: item.bind_id
            }
          })
        )
        return
      } else if (this.current === '投放组') {
        cb(
          data.data.list.map(item => {
            return {
              value: item.release_group_name,
              id: item.id
            }
          })
        )
        return
      }
      cb(
        data.data.list.map(item => {
          return {
            value: item.name,
            id: item.id
          }
        })
      )
    },

    // 确定
    determine() {
      if (this.judgmentParameters()) {
        console.log('进来了')
        const parameter = this.assemblyParameters()
        this.$emit('determine', parameter)
      }
    },

    // 判断参数
    judgmentParameters() {
      let text = null

      if (!this.parameter.release_group_id) {
        text = '请选择投放组'
      } else if (!this.parameter.pitcher_id) {
        text = '请选择投手'
      } else if (!this.date || !this.date.length) {
        text = '请选择日期'
      }
      text &&
        this.$message({
          message: text,
          type: 'warning'
        })
      return !text
    },

    // 组装参数
    assemblyParameters() {
      const obj = {
        begin_time: this.date[0],
        end_time: this.date[1],
        release_group_id: this.parameter.release_group_id,
        pitcher_id: this.parameter.pitcher_id,
        mini_program_id: this.parameter.mini_program_id
      }

      return obj
    },

    // 初始化
    init() {
      if (this.drawerItem.begin_time && this.drawerItem.end_time) {
        // 时间
        this.date[0] = this.drawerItem.begin_time
        this.date[1] = this.drawerItem.end_time
      }

      // 投放组
      this.parameterNames.release_group_id_name = this.drawerItem.release_group_name
      this.parameter.release_group_id = this.parameterNames.release_group_id_name && this.drawerItem.release_group_id

      // 投手
      this.parameterNames.pitcher_id_name = this.drawerItem.pitcher_name
      this.parameter.pitcher_id = this.parameterNames.pitcher_id_name && this.drawerItem.pitcher_id
      // 小程序
      this.parameterNames.mini_program_name = this.drawerItem.mini_program
      this.parameter.mini_program_id = this.parameterNames.mini_program_name && this.drawerItem.mini_program_id
    }
  }
}
</script>

<style scoped>
.item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.item .title {
  display: inline-block;
  width: 110px;
}

.checkBox {
  margin-bottom: 26px;
}

.checkBox_title {
}

.checkBox_content {
}

.content_item {
}
</style>
